import Settings from 'Settings'
import AnalyticsUtils from '@daedalus/core/src/analytics/utils'

import getAnonymousId from 'components/data/URLParams/selectors/getAnonymousId'

const ANALYTICS_ENDPOINT = Settings.get('REACT_APP_ANALYTICS_ENDPOINT')
const API_KEY = Settings.get('REACT_APP_ANALYTICS_API_KEY')
const GTM_CONTAINER_ID = Settings.get('REACT_APP_GTM_ID')

const initializeSDK = () => {
  const integrations = {
    'Segment.io': {
      apiKey: API_KEY,
      apiHost: ANALYTICS_ENDPOINT
    },
    'Google Tag Manager': {
      containerId: GTM_CONTAINER_ID,
      // This prevents double page view tracking
      trackCategorizedPages: false
    }
  }

  AnalyticsUtils.initialize(integrations, getAnonymousId())
}

export default initializeSDK
